/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import img from '../../shared/img/logo/logo.png';
import PasswordForm from './components/PasswordForm';
import LoginForm from './components/LogInForm';
import RecoveryForm from './components/RecoveryForm';
import config from '../../config';

const queryString = require('query-string');

function Copyright() {
  return (
    <Typography
      variant="caption"
      style={{
        width: '100%', color: '#555555', textAlign: 'center',
      }}
    >
      <code>
        v
        {process.env.REACT_APP_VERSION}
      </code>
      <br />
      Copyright ©
      <Link color="inherit" href="https://englishworld.fr/">
        English World
      </Link>
      {' '}
      {new Date().getFullYear()}
      .
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '80vh',
    width: '80%',
    boxShadow: '0px 0px 10px 1px rgb(0, 0, 0, 0.3)',
    borderRadius: '20px',
  },
  paperContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    backgroundColor: 'white',
    borderRadius: '20px',
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
  },
  image: {
    backgroundImage: `url(${config.OBJECT_URL}/thumbnail/MW_LANDING_${Math.floor((Math.random() * 6) + 1)}.svg)`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '20px 0px 0px 20px',
  },
  paper: {
    margin: theme.spacing(4, 4),
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const NewPassword = () => {
  const [status, setStatus] = useState(0);
  const [passwordToken, setpasswordToken] = useState();
  const classes = useStyles();

  useEffectOnce(() => {
    let isCancelled = false;
    const token = queryString.parse(location.search);
    if (token.resettoken && token.resettoken !== null) {
      !isCancelled && setpasswordToken(token.resettoken);
      setStatus(1);
    }

    return () => {
      isCancelled = true;
    };
  });

  const form = [];
  if (status === 0) form.push(<LoginForm changeTab={setStatus} />);
  else if (status === 1) form.push(<PasswordForm passwordToken={passwordToken} changeTab={setStatus} />);
  else if (status === 2) form.push(<RecoveryForm changeTab={setStatus} />);

  return (
    <div>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{
          backgroundColor: '#f9f9f9',
          height: '100%',
          width: '100%',
          minHeight: '100vh',
          minWidth: '100vh',
          color: 'white',
        }}
      >
        <Grid container className={classes.root}>
          <Grid item xs={false} sm={4} md={7} className={classes.image} />
          <Grid item xs={12} sm={8} md={5} className={classes.paperContainer}>
            <div className={classes.paper}>
              <div>
                <img src={img} height="90px" width="60px" />
              </div>
              {form}
              <Copyright />
            </div>
          </Grid>
        </Grid>

      </Grid>
    </div>
  );
};

export default NewPassword;
